import {Pipe, PipeTransform} from '@angular/core';
import {differenceInCalendarDays} from 'date-fns';

@Pipe({
  name: 'getDifferentInCalendarDays'
})
export class GetDifferentInCalendarDaysPipe implements PipeTransform {

  transform(current: Date, sign = '<', days = 0): boolean {
    if (sign === '<') {
      return differenceInCalendarDays(current, new Date()) < days; // Apartir de hoy
    } else if (sign === '<=') {
      return differenceInCalendarDays(current, new Date()) <= days;
    } else if (sign === '>') {
      return differenceInCalendarDays(current, new Date()) > days;
    } else if (sign === '>=') {
      return differenceInCalendarDays(current, new Date()) >= days;
    } else if (sign === '=') {
      return differenceInCalendarDays(current, new Date()) === days;
    }
  }

}
